import * as React from 'react';
import { useSelector } from 'react-redux';
import Menu from '../components/navigation/mobile-menu';
import HideableComponent from '../components/utils/hideable-component';
import Auth from '../logic/redux/auth';
import LoadingScreen from '../screens/loading-screen/loading-screen';
import { ScreenSizeFloor } from '../styles/screen-sizes';
import { Routes } from './routes';
import ErrorBoundary from '../components/utils/error-boundary';

const Navigation = (): JSX.Element => {
  const loggedIn = useSelector(Auth.select.selectLoggedIn);
  if (loggedIn === undefined) {
    return <LoadingScreen />;
  }

  return (
    <>
      <HideableComponent showUntil={ScreenSizeFloor.LG}>
        <Menu />
      </HideableComponent>
      <ErrorBoundary>
        <Routes />
      </ErrorBoundary>
    </>
  );
};

export default Navigation;
